<template>
  <section class="container">
    <template v-show="isReal"/>
      <Live01 v-show="isReal" :month="month"/>
    <template />
    <template v-show="!isReal"/>
      <LiveOnline  v-show="!isReal" :month="month" :contentType="contentType" />
    <template />
  </section>
</template>

<script>
import { mapActions } from 'vuex'
// import TimeLine from '@/components/molecules/202008/TimeLine.vue'
import Live01 from '@/components/organisms/202009sendai/Live01.vue'
import LiveOnline from '@/components/organisms/202009sendai/LiveOnline.vue'
// import Live02 from '@/components/organisms/Live02.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    },
    contentType: {
      type: String
    },
    isReal: {
      type: Boolean
    }
  },
  components: {
    // TimeLine,
    Live01,
    // Live02,
    LiveOnline
  },
  data: () => ({
    online: true,
    timeline: [
      'すべて',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00'
    ]
  }),
  mounted () {
    this.resetLive()
  },
  methods: {
    ...mapActions([
      'resetLiveProgram',
      'getHyblidCompanyLivePrograms',
      'getHyblidProviderLivePrograms'
    ]),
    async resetLive () {
      await Promise.all([this.getHyblidCompanyLivePrograms(), this.getHyblidProviderLivePrograms(), this.resetLiveProgram()])
    }
  }
}
</script>

<style lang="sass" scoped>
section
  background-color: $lightpink
  padding-top: 15px
  .live /deep/
    .description
      margin-top: 5px
      p
        line-height: 1.6
        font-size: 1.2rem
    .live-programs
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      .program-wrapper
        width: calc(50% - 10px)
    .comingsoon
      padding: 50px 0
      figure
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        img
          width: 40%
        figcaption
          margin-top: 10px
          text-align: center
          line-height: 1.4
          font-size: 2rem
          font-weight: bold
</style>
